// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1FU0n","info":"UpdateTermsInfo_info__1BWOC"};